module.exports = __webpack_public_path__ + "img/linksms-big.a332a096.png";